import React from "react";
import { Link, withRouter } from "react-router-dom";
import { AppSettings } from "./../../config/app-settings.js";
import { menuMatchesLocation } from "./menuMatch.js";

class SidebarNavList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: -1,
      clicked: -1,
    };
  }

  handleExpand = (e, i, match) => {
    e.preventDefault();

    this.setState((state) => ({
      active: this.state.active === i ? -1 : i,
      clicked: 1,
    }));
  };

  handleMenuItemClick = (e, toggleAppSidebarMobile) => {
    if (window.innerWidth <= 768 && !this.props.data.children) {
      setTimeout(() => {
        if (toggleAppSidebarMobile) {
          const syntheticEvent = {
            preventDefault: () => {},
            stopPropagation: () => {},
            target: e.target,
          };
          toggleAppSidebarMobile(syntheticEvent);
        }
      }, 150);
    }
  };

  handleExpandClick = (e, i, routeMatch, toggleAppSidebarMobile) => {
    this.handleExpand(e, i, routeMatch);

    if (window.innerWidth <= 768 && this.props.data.path !== "#") {
      setTimeout(() => {
        if (toggleAppSidebarMobile) {
          const syntheticEvent = {
            preventDefault: () => {},
            stopPropagation: () => {},
            target: e.target,
          };
          toggleAppSidebarMobile(syntheticEvent);
        }
      }, 150);
    }
  };

  render() {
    const { location, data } = this.props;
    const routeMatch = menuMatchesLocation(location.pathname, data);

    var icon = data.icon && (
      <div className="menu-icon">
        <i className={data.icon}></i>
      </div>
    );
    var img = data.img && (
      <div className="menu-icon-img">
        <img src={data.img} alt="" />
      </div>
    );
    var caret = data.children && !data.badge && <div className="menu-caret"></div>;
    var label = data.label && <span className="menu-label ms-5px">{data.label}</span>;
    var badge = data.badge && <div className="menu-badge">{data.badge}</div>;
    var highlight = data.highlight && <i className="fa fa-paper-plane text-theme"></i>;
    var title = data.title && (
      <div className="menu-text">
        {data.title} {label} {highlight}
      </div>
    );

    return (
      <AppSettings.Consumer>
        {({
          handleAppSidebarOnMouseOver,
          handleAppSidebarOnMouseOut,
          appSidebarMinify,
          toggleAppSidebarMobile,
        }) => (
          <div
            className={
              "menu-item " +
              (routeMatch ? "active " : "") +
              (this.props.active ||
              (this.props.clicked === -1 && routeMatch) ||
              data.search
                ? "expand "
                : "closed ") +
              (data.children ? "has-sub " : "")
            }
          >
            {data.children ? (
              <Link
                to={data.path}
                className="menu-link"
                onMouseOver={(e) =>
                  handleAppSidebarOnMouseOver && handleAppSidebarOnMouseOver(e, data)
                }
                onMouseOut={(e) =>
                  handleAppSidebarOnMouseOut && handleAppSidebarOnMouseOut(e, data)
                }
                onClick={(e) =>
                  this.handleExpandClick(
                    e,
                    data.index || 0,
                    routeMatch,
                    toggleAppSidebarMobile
                  )
                }
              >
                {img} {icon} {title}
                {caret} {badge}
              </Link>
            ) : (
              <Link
                to={data.path}
                className="menu-link"
                onClick={(e) => this.handleMenuItemClick(e, toggleAppSidebarMobile)}
              >
                {img} {icon} {badge} {title}
                {caret}
              </Link>
            )}
            {data.children && (
              <div
                className={
                  "menu-submenu " +
                  ((this.props.active ||
                    (this.props.clicked === -1 && routeMatch) ||
                    data.search) &&
                  !appSidebarMinify
                    ? "d-block "
                    : "d-none")
                }
              >
                {data.children &&
                  data.children.map((submenu, i) => (
                    <SidebarNavList
                      data={submenu}
                      key={i}
                      expand={(e) => this.handleExpand(e, i, routeMatch)}
                      active={i === this.state.active}
                      clicked={this.state.clicked}
                    />
                  ))}
              </div>
            )}
          </div>
        )}
      </AppSettings.Consumer>
    );
  }
}

export default withRouter(SidebarNavList);
